import OrganizationBrowser from './Browser';

export default function OrganizationsList() {
    return <OrganizationBrowser />;
}
